
export function createIframe(iframeId, iframeSrc) {
  const iframNode = document.createElement('iframe');
  iframNode.id = iframeId;
  iframNode.src = iframeSrc;
  iframNode.style.width = '0px';
  iframNode.style.height = '0px';
  iframNode.style.display = 'none';
  return iframNode;
}